import React from "react";

function OurDocterSec() {
  return (
    <>
      {/* <!-- Hero Area============================================ --> */}
      <div
        className="fix col-lx-12 col-lg-12 bannermobi"
        style={{
          backgroundImage:
            "url('/assest/images/HomeImages/uknewbannerdr.png')",
          backgroundSize: "cover",
          // background:"black",
          // borderBottom:"solid"
        }}
      >
        <div className="container">
          {/* <img src="/assest/images/HomeImages/Layer5.png" /> */}
          <div className="hero-slide-content float-right text-right heromobi">
            <div className="row gy-4">
              <div className="col-md-8" data-aos="flip-down">
                <img
                  alt="our1"
                  src="/assest/images/HomeImages/section3.png"
                  style={{ marginBottom: "-2px" }}
                />
              </div>
              <div
                className="col-md-4"
                style={{
                  height: "auto",
                  flexDirection: "column",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {/* <h3>welcome to VT</h3> */}
                <h3
                  data-aos="fade-down"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="1000"
                  style={{
                    textAlign: "right",
                    fontWeight: "600",
                    fontSize: "32px",
                    fontFamily: "sans-serif",
                    paddingBottom: "0px",
                  }}
                >
                  UNIVERSAL REACH, LOCAL EXPERTISE: ENGAGE WITH TOP LEGAL PROFESSIONALS ANYWHERE, ANYTIME!
                </h3>
                <br />

                <p
                  data-aos="fade-left"
                  style={{
                    textAlign: "right",
                    fontFamily: "sans-serif",
                    fontSize: "14px",
                    paddingBottom: "2rem",
                    color:"white"
                  }}
                >
                 With our worldwide reach, whether you need legal counsel, advice on legal matters, document processing, or specialized consultations, connecting with a legal professional within minutes is just a click away. Bid farewell to the constraints of time and distance and welcome a new era of legal service excellence. Schedule your appointment now and relish the seamless convenience of our globally acclaimed Lawfully platform.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OurDocterSec;
